<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
  <title>Terms and Conditions</title>
  <style>
    body {
      margin: 0;
      font-family: 'Poppins', sans-serif;
      background-color: #f9f9f9;
    }
    header {
      background-color: #333;
      color: #fff;
      padding: 20px;
      text-align: center;
    }
    header h1 {
      margin: 0;
      font-size: 24px;
    }
    main {
      flex: 1;
      padding: 20px;
    }
    section {
      max-width: 800px;
      margin: 0 auto;
      background-color: #fff;
      padding: 20px;
      box-shadow: 0 0 10px rgba(0,0,0,0.1);
    }
    section h2 {
      font-size: 20px;
      margin-top: 20px;
      margin-bottom: 10px;
    }
    section p {
      font-size: 16px;
      line-height: 1.5;
      color: grey;
    }

    
    footer {
      background-color: #333;
      color: #fff;
      text-align: center;
      padding: 10px;
    }
    @media (max-width: 600px) {
      header h1 {
        font-size: 20px;
      }
      section {
        padding: 10px;
      }
      section h2 {
        font-size: 18px;
      }
      section p {
        font-size: 14px;
      }
    }
  </style>
</head>
<body>

  <div style="display: flex; flex-direction: column; min-height: 100vh;">

   

    <!-- Main Content -->
    <main>
      <section>
        <h2>Terms and <span style="color: #F87C56;">Conditions of Service</span></h2>
        <p style="color: black;">Last Updated: April 21, 2025</p>

        <p>
          Welcome to Plug P2P! These Terms and Conditions of Service (“Terms”) constitute a legally binding agreement between you and Plug P2P, Inc. (“Plug P2P,” “we,” “us,” the “company”, or “our”), governing your access to and use of our website, mobile Platform, and all related offerings (collectively, the “Platform”). Please read the Terms carefully before accessing the Platform. By accessing the Platform (whether or not you register as a user) or by clicking your acceptance of the Terms, you accept and agree to be bound and abide by the Terms and our <a href="https://admin.plugp2p.com/privacy-policy/Redirection" style="text-decoration: underline;color: blue;">Privacy Policy</a>,
           and you consent to all actions we take with respect to your information consistent with our Privacy Policy, incorporated herein by reference. Plug P2P reserves the right to amend or modify these Terms and the Privacy Policy at any time and your continued use of the Platform constitutes your agreement to be bound by these Terms and our Privacy Policy, as amended or modified. If you do not agree to these Terms or the Privacy Policy, you must not access the Platform.
          <span style="font-weight: bold;color: black;">The Terms provide that you and Plug P2P agree to resolve all disputes between us through binding individual arbitration and include a class action waiver and jury trial waiver.
            The Terms further provide that you waive any protections under California Civil Code §1542, or any similar law, stating that a general release does not extend to claims which the creditor does not know or suspect to exist in his or her favor at the time of executing the release.</span> 
        </p>

        <h2 style="text-decoration: underline; font-weight: bold;">Definitions</h2>

        <div style="margin-left: 40px;">
          <p><span style="color: black; font-weight: bold;">Participants:</span> All users of the Platform, including “Charge Hosts” or “Hosts” (those offering EV charging services) and “Charge Guests” or “Guests” (those seeking EV charging services), individually or collectively referred to as “user”, “users”, “you”, or “your.”</p>
        
          <p><span style="color: black; font-weight: bold;">EV:</span> Electric Vehicle.</p>
        
          <p><span style="color: black; font-weight: bold;">EVSE:</span> Electric Vehicle Supply Equipment (e.g., EV chargers).</p>
        
          <p><span style="color: black; font-weight: bold;">EV charging device:</span> Qualified EVSE or electrical outlet.</p>
        
          <p><span style="color: black; font-weight: bold;">Qualified EV charging device:</span> EV charging device that meets all of the following criteria: (a) is of a design and confirmed electrical characteristics that are supported by the Platform, including the selectable images and values for device type, connector or outlet type, voltage, amperage, and power; (b) must be installed or validated for EV charging by a licensed electrician; (c) meets all national and local electrical code safety standards and guidelines, including but not limited to National Electrical Code (NEC) safety standards.</p>
        
          <p><span style="color: black; font-weight: bold;">Services:</span> EV charging and related products or services offered by Charge Hosts via the Platform.</p>
        
          <p><span style="color: black; font-weight: bold;">Reservation:</span> A booking for Services, forming a contract directly between a Charge Host and Charge Guest.</p>
        
          <p><span style="color: black; font-weight: bold;">Total Amount:</span> The amount a Charge Guest must pay to book a Reservation, including service fees, taxes, and other charges (e.g., Total (USD)).</p>
        
          <p><span style="color: black; font-weight: bold;">Payment Method:</span> A credit card or other valid method of payment that is accepted by our third-party processors (e.g., Stripe) and that is acceptable to Plug P2P and used to process payments via the Platform.</p>
        
          <p><span style="color: black; font-weight: bold;">Content:</span> Any materials (e.g., photos and reviews) that a Participant submits or uploads to the Platform.</p>
        </div>
        
        <h2>1.Overview of Plug P2P</h2>

<p>
Plug P2P provides the Platform as a marketplace enabling Participants to publish, offer, search for, schedule, and pay for EV charging Services, and rate and review other Participants with whom you have engaged in a transaction via the Platform. We facilitate these transactions and interactions but do not own, control, or manage the Services or EV charging devices. Plug P2P is not a party to contracts between Charge Hosts and Charge Guests, nor does it operate as an EV charging operator, real estate agency, or insurer. We act strictly as a facilitator for transactions and corresponding payment processing.
</p>

<h2>2.Eligibility and Account Registration</h2>

<p>
2.1 You must be at least 18 years old and legally capable of entering into contracts.
</p>

<p>
2.2 To access certain features, you must register an account with accurate, current, and complete information (e.g., name, email, phone number, and payment details) and must keep that information up to date as long as you are a Participant. By providing your information, you give us permission to contact you via email, call, text and notification.
</p>

<p>
2.3 You are responsible for maintaining the confidentiality of your account credentials and all activities under your account. Notify us immediately at <a href="mailto:email@plugp2p.com">email@plugp2p.com</a> if you suspect unauthorized use.
</p>

<p>
2.4 You may not transfer your account to another party without our prior written consent.
</p>

<h2>3.Charge Guest Terms</h2>

<p style="color: black;">3.1 Searching and Booking</p>
<div style="margin-left: 25px;">
  <p>
    a) Charge Guests may search for Services using filters such as location, device type, device characteristics, cost, availability, and other factors supported by the Platform. Search results may be ranked based on factors like Guest preferences, Participant ratings, Host responsiveness, and other factors, as determined by Plug P2P in its sole discretion.
  </p>

  <p>
    b) Charge Guests understand and agree that: (a) Services are not provided by Plug P2P, but directly by Charge Hosts and (b) Charge Hosts are not selected, vetted, rated or endorsed by Plug P2P, and (c) Charge Hosts are solely responsible for the accuracy and completeness of their listings of EV charging devices and all aspects of the Services, including without limitation, that the location of the EV charging device is accurately reflected on major navigation apps.
  </p>

  <p>
    c) Booking a Reservation requires payment of the Total Amount in U.S. dollars via an authorized Payment Method.
  </p>
</div>



<p  style="color: black;">3.2 Reservation Details</p>
<div style="margin-left: 25px;">

<p>
a) A Reservation grants a Charge Guest a limited license to access the Charge Host’s property and use the specified EV charging device only during the agreed time, subject to any rules of the Reservation. No credit will be provided to a Charge Guest for any missed time.
</p>

<p>
b) Charge Guests are prohibited from unauthorized activities, including without limitation, commercial charging resale, tampering with an EV charging device or hindering or blocking Charging Hosts or another Guest’s access to the property.
</p>


<p>
c) Charge Hosts may occupy the property during the Reservation and, if offering “Contactless Charging,” will minimize physical interaction unless requested by Charge Guest. Charge Guest acknowledges and accepts that some interaction with the Charge Host or Charge Host representatives may occur in some instances. Charge Guests may not violate the privacy or other rights of a Charge Host by requesting to or entering a Charge Host’s property beyond the Services.
</p>

<p>
d) Participants must comply with all applicable laws, ordinances, and regulations.
</p>

<p>
e) Participants must comply with all manufacturer and owner’s manuals, guidelines, and instructions for their respective devices or vehicle as applicable.
</p>

<p>
f) Participants are permitted to have cameras and other recording devices in and on their vehicle and property, in compliance with applicable federal, state and local laws, rules, and regulations. Cameras and other recording devices in restrooms accessible by Charge Guests are absolutely prohibited.
</p>

<p>
g) If a Charge Host has more than one EV charging device, the Charge Guest may only utilize the EV charging device that is the subject of the Reservation and may not block access to any other EV charging device.
</p>

<p>
h) Guests must vacate the property promptly at the Reservation’s scheduled end time, leaving the EV charging device and all related and surrounding real and personal property in its original condition.
</p>

<p>
i) Guests are liable to Hosts for any overstay penalties.
</p>
</div>


<p style="color: black;">3.3 Cancellations and Refunds</p>

<div style="margin-left: 25px;">
  <p style="color: black; font-size: 14px;">a) Host Cancellations:</p>
  <p>
    If a Host cancels at any time, the Guest receives a full refund.
  </p>

  <p style="color: black; font-size: 14px;">b) Guest Cancellations:</p>
  <p>
    Cancellations made 24 hours or more before the Reservation start time receive a full refund; cancellations made within 24 hours of the Reservation start time forfeit the Total Amount, unless otherwise determined by Plug P2P in its sole discretion. Reservations not cancelled by the Guest but not completed for any reason are non-refundable, unless otherwise determined by Plug P2P in its sole discretion.
  </p>

  <p style="color: black; font-size: 15px;">c) Issues During A Reservation:</p>
  <p>
    Report problems to <a href="mailto:email@plugp2p.com" style="text-decoration: underline;">email@plugp2p.com</a> promptly. Plug P2P may, in its sole and complete discretion, investigate, aid, or determine refunds.
  </p>
</div>


<p style="color: black;font-size: 15px;">3.4 Responsibilities and Risks</p>
<div style="margin-left: 25px;">

<p>
a) Charge Guests are responsible for their actions, those of their companions (e.g., pets, minors and all others accompanying Guest), and compliance with all applicable federal, state, and local laws, rules and regulations; third-party guidelines and agreements; Reservation rules and conditions of use (e.g., Host Comments, Host Answers To Key Questions, Max Amperage limits); and vehicle manufacturer and EV charging device manufacturer recommendations, safety practices, and guidelines. Guests must have any accompanying pets in their full control at all times. Guests are responsible for any damages or loss caused by Guest, their pets and companions, or faulty Guest property (including vehicle and mobile charging devices).
</p>

<p>
b) To the fullest extent permitted by law, Charge Guests assume all risks related to using the Platform and Services, including, without limitation, property damage, personal injury, death, and incompatibility with or damage to their EV.
</p>
</div>


<h2>4.Charge Host Terms</h2>
<p style="color: black;font-size: 15px;">4.1 Participation</p>
<p>
<div style="margin-left: 25px;">


<p>
a) Charge Hosts may list EV charging devices on the Platform, setting price, availability, and conditions of use, provided all information is accurate and complete and updated as needed. If update is needed to EV charging device or listing criteria that is non-editable, the Host must delete the listing and create a new listing with the correct information. Host may be required to cancel or decline pending and confirmed Reservations before changes can be made to a listing.
</p>

<p>
b) Upon accepting a Reservation, Charge Hosts enter into direct contracts with Charge Guests and agree to deliver Services as contracted.
</p>

<p>
c) Charge Hosts should doublecheck the time of each Reservation request and Reservation, making sure that they do not fall on any blocked dates and to prevent double booking.
</p>
</div>


<p style="color: black;font-size: 15px;">4.2 Independence</p>
<div style="margin-left: 25px;">

<p>
Charge Hosts are independent contractors, not employees or agents of Plug P2P, which acts only as the facilitator of transactions and payment processing. Charge Hosts retain full discretion over their offerings, subject to these Terms.
</p>
</div>

<p style="color: black;">4.3 Responsibilities and Risks</p>
<div style="margin-left: 25px;">

<p>
a) Charge Hosts must ensure that both their EV charging device(s) and their property are open and accessible (e.g., not located within a locked gate or garage) during accepted Reservation times, are clearly identified with appropriate signage, and are safe, fully operable, and accurately represented (e.g., voltage, amperage, power). If needed, Charge Hosts should independently consult a qualified licensed electrician before listing any offering.
</p>

<p>
b) Charge Hosts represent and warrant that they will offer and list, on the Platform, only qualified EV charging devices that meet the following criteria: 
<ul>
  <p style="color: grey;">(a) are of a design and confirmed electrical characteristics that are supported by the Platform, including the selectable images and values for device type, connector or outlet type, voltage, amperage, and power;</p>
  <p style="color: grey;">(b) must be installed or validated for EV charging by a licensed electrician;</p>
  <p style="color: grey;">(c) meet all national and local electrical code, safety standards, and guidelines, including but not limited to National Electrical Code (NEC) safety standards.</p>
</ul>


<p>
c) If a Charge Host is offering more than one EV charging device, the Host must clearly identify the specific EV charging device being offered.
</p>

<p>
d) Charge Hosts are fully liable for their actions and omissions, and those of any co-Hosts or team members assisting with Services. Charge Hosts are responsible for ensuring that the location of the EV charging device is accurately reflected on major navigation apps.
</p>

<p>
e) Charge Hosts must fully comply with all applicable federal, state, and local laws and regulations, permits, building codes, and third-party agreements (e.g., leases, HOA rules). Charge Hosts must disclose and inform Charge Guests of any applicable local laws or ordinances (e.g., leash laws, noise ordinances, etc.).
</p>

<p>
f) Hosts assume all risks to themselves, to any third parties, and to their respective property, associated with offering Services, including without limitation, faulty Host property (including electrical infrastructure and listed charging device hardware), power supply issues, property damage, injury, or loss caused by or resulting from Guest interactions, and Hosts should secure and maintain appropriate insurance coverages.
</p>
</div>

<p style="color: black;">4.4 Cancellations and Changes</p>
<div style="margin-left: 25px;">

<p>
a) Charge Hosts should avoid cancellations except in emergencies or as required by law, notifying Charge Guests promptly if cancellation is necessary.
</p>

<p>
    b) Late cancellations (within 24 hours of Reservation start time) may incur fees or penalties. Charge Hosts may owe Charge Guests or Plug P2P compensation for resulting damages or losses, including but not limited to towing fees or fees associated with alternative emergency charging arrangements. Fees and penalties may take the form of deductions from past, current, or future payments, or other collection action, in our sole discretion, to the fullest extent permitted by law.
    </p>
</div>
    
    <p style="color: black;">4.5 Taxes</p>
<div style="margin-left: 25px;">

    <p>
    Charge Hosts are solely responsible for determining and remitting applicable taxes (e.g., sales, income). Where Plug P2P collects and remits estimated taxes on behalf of Charge Hosts, we will do so at our sole discretion and will notify Charge Hosts of any taxes remitted on their behalf via transaction summaries, which may be issued periodically.
    </p>
</div>
    
    <p style="color: black;">5. General Platform Rules and Content Standards Terms</p>
    <p style="color: black;">5.1 You agree not to use the Platform:</p>
    
    <ul>
      <p style="color: grey;">a) In any way that violates any of these Terms or any applicable federal, state, local, or international law, rule or regulation (including, without limitation, any laws regarding the export of data or software to and from the United States or other countries);</p>
      <p style="color: grey;">b) For the purpose of exploiting, harming, or attempting to exploit or harm other Participants in any way by exposing them to inappropriate Content, such as Content that is defamatory, obscene, indecent, abusive, offensive, harassing, violent, hateful, inflammatory, or otherwise objectionable, asking for personally identifiable information, or otherwise;</p>
      <p style="color: grey;">c) To transmit, or procure the sending of, any advertising or promotional material without our prior written consent, including any "junk mail," "chain letter," "spam," or any other similar solicitation, or to give the impression that they emanate from or are endorsed by us or any other person or entity, if this is not the case.</p>
      <p style="color: grey;">d) To engage in fraud or impersonate or attempt to impersonate Plug P2P, a company employee, another Participant, or any other person or entity (including, without limitation, by using email addresses, mobile or telephone numbers, or screen names associated with any of the foregoing);</p>
      <p style="color: grey;">e) To promote (i) sexually explicit or pornographic material, (ii) violence, or (iii) discrimination based on religion, race, color, national origin, age, sex, sexual orientation, or marital status;</p>
      <p style="color: grey;">f) To engage in any other conduct that restricts or inhibits anyone's use or enjoyment of the Platform, or which, as determined in our sole discretion, may harm Plug P2P or users of the Platform or expose them to liability;</p>
      <p style="color: grey;">g) In any manner that could disable, overburden, damage, or impair the Platform or interfere with any other Participant’s use of the platform, including their ability to engage in real-time activities through the Platform;</p>
      <p style="color: grey;">h) To promote commercial activities or sales, such as contests, sweepstakes, and other sales promotions, barter, or advertising;</p>
      <p style="color: grey;">i) Use any robot, spider, or other automatic device, process, or means to access the Platform for any purpose, including monitoring or copying any of the material on the Platform, including without limitation, scraping;</p>
      <p style="color: grey;">j) Use any manual process to monitor or copy any of the material on the Platform or for any other unauthorized purpose without our prior written consent;</p>
    </ul>

<div style="margin-left: 25px;">
    
    <p>
        k) Use any device, software, or routine that interferes with the proper working of the Platform;
        </p>
        
        <p>
        l) Introduce any viruses, trojans, worms, logic bombs, or other material that is malicious or technologically harmful;
        </p>
        
        <p>
        m) Attempt to gain unauthorized access to, interfere with, damage, or disrupt any parts of the Platform, the server on which the Platform is stored, or any server, computer, or database connected to the Platform;
        </p>
        
        <p>
        n) Attack the Platform via a denial-of-service attack or a distributed denial-of-service attack; or
        </p>
        
        <p>
       o) Otherwise attempt to interfere with the proper working of the Platform.
        </p>
</div>
        
        <p style="color: black;">6. Intellectual Property Rights and Trademarks</p>
        <p>
        6.1 You grant Plug P2P a worldwide, perpetual, royalty-free license to use any Content submitted or uploaded by you for any activity by us or on our behalf relating to the operation and promotion and improvement of the Platform.
        </p>
        
        <p>
        6.2 You warrant that your Content is lawful, accurate, and does not infringe any third-party rights. Plug P2P may remove violating Content at its sole discretion and without notice to you.
        </p>
        
        <p>
        6.3 The Platform and its entire contents, features, and functionality (including but not limited to all information, software, text, displays, images, video, and audio, and the design, selection, and arrangement thereof) are owned by Plug P2P, its licensors, or other providers of such material and are protected by United States and international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.
        </p>
        
        <p>
        6.4 The Terms permit you to use the Platform for your own personal use consistent with the purposes of the Platform and for no other commercial use (“Personal Use”). You must not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on our Platform, except as follows:
        </p>
        
        <ul>
          <p style="color: grey;">a) Your mobile device may temporarily store copies of such materials in RAM incidental to your accessing and viewing those materials.</p>
          <p style="color: grey;">b) You may store files that are automatically cached by your device for display enhancement purposes.</p>
          <p style="color: grey;">c) If we provide desktop, mobile, or other third-party platforms for download, you may download a single copy to your device solely for your Personal Use, provided you agree to be bound by these Terms and any applicable end user license agreement for such platforms.</p>
        </ul>
        
        <p style="color: black;">
        6.5 You must not:
        </p>
        
        <ul>
          <p style="color: grey;">a) Modify copies of any materials from this site;</p>
          <p style="color: grey;">b) Use any illustrations, photographs, video or audio sequences, or any graphics separately from the accompanying text;</p>
          <p style="color: grey;">c) Delete or alter any copyright, trademark, or other proprietary rights notices from copies of materials from this site;</p>
          <p style="color: grey;">d) Access or use for any commercial purposes any part of the Platform or any services or materials available through the Platform, other than as permitted by these Terms.</p>
        </ul>
        
        <p style="color: black;">6.6 Reliance on Information Posted</p>
        
        <div style="margin-left: 25px;">

        
<p>
a) The information presented on or through the Platform is made available solely for general information purposes. We do not warrant the accuracy, completeness, or usefulness of this information. Any reliance you place on such information is strictly at your own risk. We do not undertake to preview Content and cannot ensure prompt removal of objectionable material after it has been posted. We disclaim all liability and responsibility arising from any reliance placed on such materials by you or any other visitor to the Platform, or by anyone who may be informed of any of its contents.
</p>

<p>
b) This Platform includes content provided by third parties, including materials provided by Participants, third-party licensors, syndicators, aggregators, and/or reporting services. All statements and/or opinions expressed in these materials, and all information, messages, and other content, other than the content provided by Plug P2P, are solely the responsibility of the person or entity providing those materials. These materials do not reflect the assessment of Plug P2P. We are not responsible or liable to you or any third party for the content or accuracy of any materials provided by any third parties.
</p>
</div>
<div style="margin-left: 25px;">
  
<p>
  6.7 No right, title, or interest in or to the Platform or any content on the Platform is transferred to you, and all rights not expressly granted are reserved by Plug P2P. Any use of the Platform not expressly permitted by these Terms is a breach of these Terms and may violate copyright, trademark, and other laws.
</p>
</div>
<div style="margin-left: 25px;">

<p>
6.8 The Plug P2P name, logo, and all related names, logos, product and service names, designs, terms, and slogans are trademarks of Plug P2P or its affiliates or licensors. You must not use such marks without the prior written permission of Plug P2P. All other names, logos, product and service names, designs, and slogans on this Platform are the intellectual property of their respective owners.
</p>
</div>

<p style="color: black;">
6.9 We have the right to:
</p>

<ul>
  <p  style="color: grey;">a) Remove or refuse to post any Participant contributions for any or no reason in our sole discretion;</p>
  <p style="color: grey;">b) Take any action with respect to any Participant contribution that we deem necessary or appropriate in our sole discretion, including if we believe that such Participant contribution violates the Terms, including the Platform Rules or Content Standards, infringes any intellectual property right or other right of any person or entity, threatens the personal safety of Platform Participants or the public, or could create liability for Plug P2P;</p>
  <p style="color: grey;">c) Disclose your identity or other information about you to any third party who claims that material posted by you violates their rights, including their intellectual property rights or their right to privacy;</p>
 <p style="color: grey;">d) Take appropriate legal action, including referral to law enforcement, for any illegal or unauthorized use of the Platform; or</p>
  <p  style="color: grey;">e) Terminate or suspend your account and your access to all or part of the Platform for any or no reason, including without limitation, any violation of these Terms.</p>
</ul>

<p>
6.10 Without limiting the foregoing, we have the right to cooperate fully with any law enforcement authorities or court order requesting or directing us to disclose the identity or other information of anyone posting any listing or materials on or through the Platform.
</p>

<p style="color:black">7. Payment Terms</p>
<p style="color:black;font-size: 15px;">7.1 Overview</p>
<div style="margin-left: 25px;">

<p>
    a) Plug P2P, via third-party processors (e.g., Stripe), facilitates payments by collecting the Total Amount from Charge Guests and remitting payments to Charge Hosts, less applicable fees, discounts, credits and specified taxes.
    </p>
    
    <p>
    b) All payments are in U.S. dollars. Participants must provide valid Payment Methods and maintain accurate bank account and billing information. By using the Platform, you acknowledge and agree that we may earn income from funds in our accounts while transactions are being reconciled and processed.
    </p>
</div>
    
    <p style="color:black;font-size: 15px;">7.2 Guest Payments</p>
<div style="margin-left: 25px;">
    
    <p>
    a) Guests authorize Plug P2P to charge their Payment Method for the Total Amount (e.g., Total (USD)) upon booking and for additional amounts (e.g., damage claims) as needed.
    </p>
    
    <p>
    b) Refunds follow applicable cancellation policies. Plug P2P is not liable for third-party fees (e.g., credit card fees, currency conversion).
    </p>
</div>
    
    <p style="color:black;font-size: 15px;">7.3 Host Payments</p>
<div style="margin-left: 25px;">
    
    <p>
    a) Hosts generally receive payments via direct deposit into a bank account provided by Host within ten (10) business days after Reservation end time, provided no claims are filed in association with the Reservation. Host is responsible for providing and maintaining accurate bank account information.
    </p>
    
    <p>
    b) Plug P2P may withhold or adjust payments for cancellations, fraud, or investigations. Plug P2P reserves the right to make adjustments or corrections in the event of payment errors, process incompatibilities, or delays (e.g., software or differences in reconciliation of calculations, such as truncating or rounding of calculations, including between the Platform and third-party payment providers).
    </p>
    </div>
    
    <p style="color:black;font-size: 15px;">7.4 Cancellation Policy</p>
    
    <ul>
      <p style="color: grey;">a) Reservations cancelled by the Charge Guest before the Charge Host has accepted the Reservation request will be refunded.</p>
      <p style="color: grey;">b) Reservations cancelled by the Charge Guest after the Charge Host has accepted the Reservation request but twenty-four (24) hours or more before the Reservation start time will be refunded.</p>
      <p style="color: grey;">c) Reservations cancelled by the Charge Guest after the Charge Host has accepted and with less than twenty-four (24) hours to Reservation start time are non-refundable.</p>
      <p style="color: grey;">d) Reservations cancelled by the Charge Host at any time will be fully refunded.</p>
      <p style="color: grey;">e) Reservations and Reservation Requests that are not cancelled but not completed for any reason are non-refundable.</p>
    </ul>
    
    <p style="color:black;font-size: 15px;">7.5 Additional Terms</p>
<div style="margin-left: 25px;">
    
    <p>
    a) Participants must comply with Payment Terms and all applicable laws and regulations.
    </p>
    
    <p>
    b) Plug P2P may suspend Platform access for non-compliance, investigation, or verification purposes, in its sole discretion.
    </p>
    
    <p>
    c) Plug P2P reserves the right, but assumes no obligation, to investigate claims and issue adjustments, in its sole discretion.
    </p>

    <p>
        d) Plug P2P may combine amounts that it collects from Guests and invest them in accordance with applicable laws; any interest earned on such investments is retained by Plug P2P.
        </p>
        </div>
        
        <p style="color:black;font-size: 15px;">8. Termination and Suspension</p>
        
        <p>
        8.1 You may terminate your account anytime by deleting your account in the Platform. Simply go to Profile, Settings, and select Delete Account in the Platform; you may be required to decline or cancel Pending and Confirmed Reservations before you delete your account.
        </p>
        
        <p>
        8.2 Plug P2P may terminate or suspend your account with thirty (30) days’ notice for any reason, or immediately for breaches of these Terms, legal violations, or to protect the Platform, in our sole discretion.
        </p>
        
        <p>
        8.3 Upon termination, surviving provisions will remain in effect, and account detail and activity may be accessible by Plug P2P for 24 months or more after account termination, or as needed to support ongoing investigations or claims, in our sole discretion or as required by law.
        </p>
        
        <p style="color:black;font-size: 15px;">9. Dispute Resolution and Arbitration</p>
<div style="margin-left: 25px;">
        
        <p style="font-weight: bold;color:black">
        Please read this section carefully because it provides that you and Plug P2P agree to resolve all disputes between you and us through binding individual arbitration and includes a class action waiver and jury trial waiver.
        </p>
</div>
        
        <p style="color:black;font-size: 15px;">9.1 Binding Arbitration</p>
<div style="margin-left: 25px;">
        
        <p style="margin-left: 35px;">
        You and Plug P2P mutually agree that:
        </p>
        
        <ul>
          <p style="color: grey;">a) Any dispute, claim or controversy arising out of or relating to these Terms or the applicability, breach, termination, validity, enforcement or interpretation thereof, or any use of or interaction with Plug P2P, the Platform, Services, Reservations, or Participants (collectively, “Disputes”) will be settled by binding arbitration on an individual basis under the Federal Arbitration Act, administered by the American Arbitration Association (the “Arbitration Agreement”);</p>
          <p style="color: grey;">b) Any question regarding arbitrability and the formation, enforceability, validity, scope, or interpretation of all or part of this Section 9, including any dispute over a party’s responsibility to pay arbitration fees, shall be resolved exclusively by an arbitrator;</p>
          <p style="color: grey;">c) The following causes of action and/or claims for relief are exceptions to the Arbitration Agreement and will be brought in a judicial proceeding in a court of competent jurisdiction: any claim or cause of action alleging actual or threatened infringement, misappropriation or violation of a party’s copyrights, trademarks, trade secrets, patents, or other intellectual property rights; any claim or cause of action seeking emergency injunctive relief based on exigent circumstances; or a request for the remedy of public injunctive relief; or any individual claim of sexual assault or sexual harassment arising from your use of the Platform or Services;</p>
          <p style="color: grey;">d) If the amount in controversy is $10,000 or less, the parties agree to proceed solely on the submission of documents to the arbitrator;</p>
          <p style="color: grey;">e) The arbitrator will issue a written decision which shall include the essential findings and conclusions upon which the arbitrator based the award. Judgment on the arbitration award may be entered in any court with proper jurisdiction. The arbitrator may award any relief allowed by law or the AAA Rules, but declaratory or injunctive relief may be awarded only on an individual basis and only to the extent necessary to provide relief warranted by the claimant’s individual claim;</p>
        </ul>
        <p  style="font-weight: bold;color:black;margin-left: 35px;">
            f) You and Plug P2P are waiving the right to a trial by jury as to all arbitrable Disputes.
            </p>
</div>
            
            <p style="color:black;font-size: 15px;">9.2 Class Action Waiver</p>
<div style="margin-left: 25px;">
            
            <p>
            a) Disputes must be individual; class actions or representative proceedings are waived by all Participants, companions, and their representatives.
            </p>
            
            <p  style="font-weight: bold;color:black">
            b) To the fullest extent permitted by law, you and Plug P2P are waiving the right to participate as a plaintiff or class Participant in any purported class action lawsuit, class-wide arbitration, private attorney general action, or any other representative or consolidated proceeding.
            </p>
</div>
            
            <p style="color:black;font-size: 15px;">9.3 Venue<p>
<div style="margin-left: 25px;">
            
            <p>
            a) Participants understand and agree that all Disputes will be resolved through arbitration in the State of Michigan, Oakland County, and that no other jurisdiction may be used except with the express written agreement of Participants and Plug P2P.
            </p>
            
            <p>
            b) Hearings may occur remotely for claims under $50K or in Oakland County, MI for claims requiring in-person representation or for claims over $50K, unless otherwise agreed. If the amount in controversy is $10,000 or less, the parties agree to proceed solely on the submission of documents to the arbitrator.
            </p>
            
            <p>
            c) You and Plug P2P each retain the right to seek resolution of the dispute in small claims court in Oakland County, Michigan, as an alternative to arbitration.
            </p>
</div>
            
            <p>
            9.4 Except as provided in this Section, if any portion of this Arbitration Agreement is deemed illegal or unenforceable, such provision will be severed and the remainder of the Arbitration Agreement will be given full force and effect.
            </p>
            
            <p style="color:black;">10. Linking to the Platform and Social Media Features</p>
            
            <p>
            10.1 You may link to our homepage, provided you do so in a way that is fair and legal and does not damage our reputation or take advantage of it, but you must not establish a link in such a way as to suggest any form of association, approval, or endorsement on our part without our express consent.
            </p>
            
            <p>
           10.2 The Platform may provide certain social media features that enable you to:
            </p>
            
            <ul>
              <p style="color: grey;">a) Link from your own or certain third-party Platforms to certain content on the Platform;</p>
              <p style="color: grey;">b) Send emails or other communications with certain content, or links to certain content, on the Platform; or</p>
              <p style="color: grey;">c) Cause limited portions of content on the Platform to be displayed or appear to be displayed on your own or certain third-party Platforms.</p>
            </ul>
<div style="margin-left: 40px;">
            
            <p>
            You may use these features solely as they are provided by us, solely with respect to the content they are displayed with, and otherwise in accordance with any additional terms and conditions we provide with respect to such features.
            </p>
            </div>
            
            <p>
            10.3 Subject to the foregoing, you must not:
            </p>
            <div style="margin-left: 25px;">
           
              <p style="color: grey;">a) Establish a link from any Platform that is not owned by you;</p>
              <p style="color: grey;">b) Cause the Platform or portions of it to be displayed on, or appear to be displayed by, any other site, for example, framing, deep linking, or in-line linking;</p>
        
            <p>
                c) Link to any part of the Platform other than the splash screen or homepage; or
                </p>
                
                <p>
                d) Otherwise take any action with respect to the materials on this Platform that is inconsistent with any other provision of these Terms of Use.
                </p>
              </div>
                
                <p>
                10.4 The Platform from which you are linking, or on which you make certain content accessible, must comply in all respects with the Content Standards set out in these Terms.
                </p>
                
                <p>
                10.5 You agree to cooperate with us in causing any unauthorized framing or linking immediately to stop. We reserve the right to withdraw linking permission without notice.
                </p>
                
                <p>
               10.6 We may disable all or any social media features and any links at any time without notice at our discretion.
                </p>
                
                <p style="color:black;">11. Links from the Platform</p>
                <div style="margin-left: 25px;">
                <p>
                If the Platform contains links to other sites and resources provided by third parties, these links are provided for your convenience only. This includes links contained in advertisements, including banner advertisements and sponsored links. We have no control over the contents of those sites or resources and accept no responsibility for them or for any loss or damage that may arise from your use of them. If you decide to access any of the third-party Platforms linked to this Platform, you do so entirely at your own risk and subject to the terms and conditions of use for such Platforms.
                </p>
                </div>
                
                <p style="color:black;">12. Geographic Restrictions</p>
                <div style="margin-left: 25px;">
                
                <p>
                The owner of the Platform is based in the State of Michigan in the United States. We provide this Platform for use only by persons located in the United States. We make no claims that the Platform or any of its content is accessible or appropriate outside of the United States. Access to the Platform may not be legal by certain persons or in certain countries. Plug P2P is not responsible or liable for any use of the Platform outside the United States. If you access the Platform from outside the United States, you do so on your own initiative and are responsible for compliance with local laws.
                </p>
                </div>
                
                <p style="color:black;">13. Legal Disclaimers and Limitations</p>
                <p  style="color:black;font-size: 15px;">13.1 Disclaimer of Warranties</p>

                <div style="margin-left: 25px;">

                
                
                <p style="color: black;font-weight: bold;">
                a)THE PLATFORM AND ALL CONTENT ARE PROVIDED “AS IS” AND “AS AVAILABLE”,
                
                
                
                WITHOUT WARRANTY OF ANY KIND AND PLUG P2P (OR ITS AFFILIATES) DISCLAIM ALL WARRANTIES, WHETHER EXPRESS OR IMPLIED, STATUTORY, OR OTHERWISE,
                
                
                
                INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT, AND FITNESS FOR A PARTICULAR PURPOSE. PLUG P2P DOES NOT GUARANTEE SAFETY, COMPATIBILITY, OR UNINTERRUPTED ACCESS. YOUR USE OF THE PLATFORM, CONTENT AND SERVICES IS AT YOUR OWN RISK.
                </p>
                
                <p>
                b) We do not endorse or warrant the existence, conduct, performance, safety, quality, legality or suitability of any Participant, Service, Reservation or third party; (ii) we do not warrant the performance or non-interruption of the Plug P2P Platform; and (iii) we do not warrant that verification, identity or other validation processes conducted on Reservations or Participants (if any) will identify past misconduct or prevent future misconduct.
                </p>
                
                <p>
                c) We do not warrant that files available for downloading from the cloud, the internet, or that the Platform will be free of viruses or other destructive code. You are responsible for implementing sufficient procedures and checkpoints to satisfy your particular requirements for anti-virus protection and accuracy of data input and output, and for maintaining a means external to our site for any reconstruction of any lost data.
                </p>

                <p>d) The disclaimers in these Terms apply to the maximum extent permitted by law. If you have
statutory rights or warranties Plug P2P (or its affiliates) cannot disclaim, the duration of any such
statutorily required rights or warranties will be limited, to the maximum extent permitted by law.</p>

                </div>
                <p style="color:black;font-size: 15px;">13.2 Limitation of Liability</p>
                <div style="margin-left: 25px;">


                <p style="color: black;font-weight: bold;">
               a) NEITHER PLUG P2P (INCLUDING ITS AFFILIATES AND PERSONNEL) NOR ANY OTHER PARTY INVOLVED IN CREATING, PRODUCING, OR DELIVERING THE PLATFORM OR ANY CONTENT WILL BE LIABLE FOR ANY INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES, INCLUDING LOST PROFITS, LOSS OF DATA OR LOSS OF GOODWILL, SERVICE INTERRUPTION, COMPUTER DAMAGE OR SYSTEM FAILURE OR THE COST OF SUBSTITUTE PRODUCTS OR SERVICES, OR FOR ANY DAMAGES FOR PERSONAL OR BODILY INJURY, INCLUDING DEATH OR DISABILITY, OR EMOTIONAL DISTRESS ARISING OUT OF OR IN CONNECTION WITH (I) THESE TERMS, (II) THE USE OF OR INABILITY TO USE THE PLATFORM OR ANY CONTENT, (III) ANY COMMUNICATIONS, INTERACTIONS OR MEETINGS YOU MAY HAVE WITH SOMEONE YOU INTERACT OR MEET WITH THROUGH, OR AS A RESULT OF, YOUR USE OF THE PLATFORM, OR (IV) PUBLISHING OR BOOKING A RESERVATION, INCLUDING THE PROVISION OR USE OF SERVICES, WHETHER BASED ON WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE), PRODUCT LIABILITY OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT PLUG P2P HAS BEEN INFORMED OF THE POSSIBILITY OF SUCH DAMAGE, EVEN IF A LIMITED REMEDY SET OUT IN THESE TERMS IS FOUND TO HAVE FAILED OF ITS ESSENTIAL PURPOSE.
                </p>
                
                <p>
                b) You further waive any protections under California Civil Code §1542, or any similar law, stating: “A general release does not extend to claims which the creditor does not know or suspect to exist in his or her favor at the time of executing the release, which if known by him or her must have materially affected his or her settlement with the debtor.”
                </p>
                
                <p style="color: black;font-weight: bold;">
                c) TO THE FULLEST EXTENT PERMITTED BY LAW, PLUG P2P’S AGGREGATE LIABILITY FOR ANY CLAIM OR DISPUTE ARISING OUT OF OR IN CONNECTION WITH THESE TERMS, YOUR INTERACTION WITH ANY PARTICIPANTS, OR YOUR USE OF OR INABILITY TO USE THE PLUG P2P PLATFORM, ANY CONTENT, OR ANY SERVICE, SHALL NOT EXCEED: (A) TO CHARGE GUESTS, THE AMOUNT YOU PAID AS A CHARGE GUEST DURING THE 3-MONTH PERIOD PRIOR TO THE EVENT GIVING RISE TO THE LIABILITY, (B) TO CHARGE HOSTS, THE AMOUNT PAID TO YOU AS A CHARGE HOST IN THE 3-MONTH PERIOD PRIOR TO THE EVENT GIVING RISE TO THE LIABILITY, OR (C) TO ANYONE ELSE, AN AMOUNT NOT TO EXCEED ONE HUNDRED U.S. DOLLARS ($100 USD).
                </p>
                </div>
                
                <p style="color:black;font-size: 15px;">13.3 Limitation on Time to File Claims</p>
                <div style="margin-left: 25px;">
                
                <p>
                Any cause of action or claim you may have arising out of or relating to these Terms or the Platform must be commenced within one (1) year after the cause of action accrues; otherwise, such cause of action or claim is permanently barred.
                </p>
                </div>
                
                <p style="color:black;font-size: 15px;">13.4 Indemnification</p>
                <div style="margin-left: 25px;">

                
                <p style="color: black;font-weight: bold;">
                TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, YOU AGREE TO RELEASE, DEFEND (AT PLUG P2P’S OPTION), INDEMNIFY, AND HOLD PLUG P2P (INCLUDING PLUG P2P PAYMENT PROCESSING PARTNERS, OTHER AFFILIATES, AND THEIR PERSONNEL) HARMLESS FROM AND AGAINST ANY CLAIMS, LIABILITIES, DAMAGES, LOSSES, AND EXPENSES, INCLUDING, WITHOUT LIMITATION, REASONABLE LEGAL AND ACCOUNTING FEES, ARISING OUT OF OR IN ANY WAY CONNECTED WITH: (I) YOUR BREACH OF THESE TERMS (INCLUDING ANY SUPPLEMENTAL OR ADDITIONAL TERMS THAT APPLY TO A PRODUCT OR FEATURE), (II) YOUR IMPROPER USE OF THE PLUG P2P PLATFORM, (III) YOUR INTERACTION WITH ANY PARTICIPANT, OR ANY PARTICIPATION IN A RESERVATION OR OTHER SERVICE, INCLUDING WITHOUT LIMITATION ANY INJURIES, LOSSES OR DAMAGES (WHETHER BODILY, COMPENSATORY, DIRECT, INCIDENTAL, CONSEQUENTIAL OR OTHERWISE) OF ANY KIND ARISING IN CONNECTION WITH OR AS A RESULT OF SUCH INTERACTION, CHARGE EXPERIENCE, PARTICIPATION OR USE, (IV) YOUR FAILURE, OR OUR FAILURE AT YOUR DIRECTION, TO ACCURATELY REPORT, COLLECT OR REMIT TAXES, OR (V) YOUR BREACH OF ANY LAWS, RULES, REGULATIONS OR THIRD PARTY RIGHTS SUCH AS INTELLECTUAL PROPERTY OR PRIVACY RIGHTS.
                </p>
                </div>
                <p style="color:black;">14. Governing Law</p>
                <div style="margin-left: 25px;">

                <p>
                Any legal suit, action, or proceeding arising out of, or related to, these Terms or the Platform shall be instituted exclusively in the State of Michigan, Oakland County, or if indicated, in the federal courts of the United States. You waive all objections to the exercise of jurisdiction over you by such courts and to venue in such courts.
                </p>
                </div>
                
                <p  style="color:black;">15. Miscellaneous</p>
                
                <p >
                15.1 Additional terms and conditions may also apply to specific portions, services, or features of the Platform. All such additional terms and conditions are hereby incorporated by this reference into these Terms.
                </p>
                
                <p  style="color:black;font-size: 15px;">15.2 Force Majeure</p>
                
                <p>
                Any delays in or failure of performance by a party shall not be considered a breach of these Terms if such delay or failure is caused by acts of God, unforeseeable circumstances, acts (including a delay or failure to act) of any governmental authority (de jure or de facto), embargoes, strikes, labor disputes, riots, fire, floods, earthquakes, wars (declared or undeclared) or other military action, terrorism, sabotage, epidemics, pandemics, state of emergency, lockdowns, travel bans, or other causes beyond a party’s reasonable control.
                </p>
                
                <p style="color:black;font-size: 15px;font-weight: bold;">15.3 Survival</p>
                
                <p>
               <span style="font-weight: bold;color: black;">The sections and subsections entitled Definitions, Responsibilities and Risks,
                Cancellation and Changes, Taxes, General Platform Rules and Content Standards, 
                Intellectual Property Rights and Trademarks, Payment Terms, Dispute Resolution and Arbitration,
                 Geographic Restrictions, Legal Disclaimers and Limitations, and Governing Law shall survive:</span> 
                 (a) the termination of these Terms and (b) your status as a Participant.
                </p>
                
                <p style="color:black;font-size: 15px;">15.4 Severability</p>
                
                <p>
                Invalid provisions will be severed without affecting remaining Terms.
                </p>
                
                <p style="color:black;font-size: 15px;">15.5 Notices</p>
                
                <p>
                Communications from Plug P2P to Participants will be electronic via email or in-app notifications.
                </p>
                
                <p style="color:black;font-size: 15px;">15.6 Contact</p>
                
                <p>
                Reach us at <a href="mailto:email@plugp2p.com" style="text-decoration: underline;">email@plugp2p.com</a> or 322 West Lincoln, Royal Oak, MI 48067.
                </p>
                                                                    


      </section>
    </main>

   

  </div>

</body>
</html>
